/**
 * Toont een banner wanneer een nieuwe SW-versie klaar staat. User moet
 * bewust op "Nu bijwerken" klikken zodat niet-opgeslagen data behouden blijft.
 */
import { useEffect, useState } from "react";
import { RefreshCw, X } from "lucide-react";
import { registerServiceWorker, activateWaitingWorker } from "@/lib/pwa";

export default function PwaUpdateBanner() {
  const [reg, setReg] = useState(null);

  useEffect(() => {
    registerServiceWorker((r) => setReg(r));
  }, []);

  if (!reg) return null;

  return (
    <div
      className="fixed top-3 inset-x-3 z-50 rounded-lg border border-amber-200 bg-amber-50 shadow-lg p-3 flex items-center gap-3 max-w-md mx-auto"
      role="alert"
      data-testid="pwa-update-banner"
    >
      <RefreshCw className="h-4 w-4 text-amber-700 shrink-0" />
      <div className="flex-1 text-xs text-amber-900 leading-tight">
        <div className="font-semibold">Nieuwe versie beschikbaar</div>
        <div>Bijwerken herlaadt de app.</div>
      </div>
      <button
        onClick={() => activateWaitingWorker(reg)}
        data-testid="pwa-update-btn"
        className="text-xs font-semibold text-white bg-amber-700 px-3 py-1.5 rounded-md"
      >
        Nu bijwerken
      </button>
      <button onClick={() => setReg(null)} className="p-1 text-amber-700" aria-label="Later" data-testid="pwa-update-later">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
